var map = {
	"./price_list_ch.png": "2fe3",
	"./price_list_de.png": "3b5a",
	"./price_list_fr.png": "a06a",
	"./price_list_it.png": "a2ed",
	"./price_list_nl.png": "9482"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "65ed";